// 2026-09-24 - FormuLearning - Step 1 주성분 확정 확인 (이슈 #75 G4, M915-04)
// 파일 위치: frontend/src/features/step3/substanceFix.ts
// 목적: 프로세스 v1.23 `BR-STEP-03`. Step 3 를 **사용자가 처음 저장할 때** «주성분이 확정됩니다» 를
//       묻고, 확인이면 서버에 확정 시각을 남긴다. 확정 뒤 재검색·이력 복원은 Step 1 카드가 막는다(화면 판정).
//   - explicit=true  : Save and continue 등 **명시 저장**. 거절한 적이 있어도 다시 묻는다.
//   - explicit=false : Autosave 즉시 저장. 한 번 거절하면 **다시 묻지 않고 false** — 호출부가 버퍼로 돌린다
//                      (입력마다 확인창이 뜨지 않게. 편집은 미저장으로 남고 명시 저장 때 다시 묻는다).
//   대조약 선택에 따른 자동 채움(`BR-S3-10`)은 이 경로를 타지 않는다 — 사용자 저장이 아니다.

import { getStep1, fixSubstance } from '../../api/step1'
import { useSubstanceSync } from '../../stores/substanceSyncStore'

const CONFIRM_MESSAGE = [
  'Step 3 를 저장하면 Step 1 의 주성분이 확정됩니다.',
  '확정 뒤에는 주성분 재검색·검색 이력 복원을 할 수 없고, 다른 주성분으로 진행하려면 새 프로젝트를 만들어야 합니다.',
  '(대조약은 Step 4 로 넘어가기 전까지 다시 고를 수 있습니다.)',
  '',
  '계속하시겠습니까?',
].join('\n')

const fixedProjects = new Set<string>()
const declinedProjects = new Set<string>()
const inflight = new Map<string, Promise<boolean>>()

/** 확정돼 있거나 지금 확정했으면 true. 사용자가 거절하면 false(저장하지 않는다). */
export function ensureSubstanceFixed(projectId: string, explicit: boolean): Promise<boolean> {
  if (fixedProjects.has(projectId)) return Promise.resolve(true)
  if (!explicit && declinedProjects.has(projectId)) return Promise.resolve(false)
  // 연속 입력이 확인창을 겹쳐 띄우지 않도록 진행 중 확인을 공유한다.
  const running = inflight.get(projectId)
  if (running) return running
  const p = (async () => {
    const s1 = await getStep1(projectId)
    if (s1.substance_fixed_at) {
      fixedProjects.add(projectId)
      return true
    }
    if (!window.confirm(CONFIRM_MESSAGE)) {
      declinedProjects.add(projectId)
      return false
    }
    await fixSubstance(projectId)
    fixedProjects.add(projectId)
    declinedProjects.delete(projectId)
    useSubstanceSync.getState().bump() // Step 1 카드가 확정 표식·잠금을 반영한다
    return true
  })().finally(() => inflight.delete(projectId))
  inflight.set(projectId, p)
  return p
}
